import React, { useRef, useEffect, useState } from "react";
import { Message } from "@/services/chatService";
import { MessageItem } from "./MessageItem";
import { Loader2 } from "lucide-react";

interface MessageListProps {
  messages: Message[];
  loading: boolean;
}

export const MessageList: React.FC<MessageListProps> = ({ 
  messages, 
  loading 
}) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const messagesContainerRef = useRef<HTMLDivElement>(null);
  const [previousMessageCount, setPreviousMessageCount] = useState(0);
  
  // Scroll to bottom only when new messages are added (not on initial load)
  useEffect(() => {
    if (messages.length > previousMessageCount && previousMessageCount > 0) {
      // Only scroll if a new message was added (not on initial load)
      if (messagesContainerRef.current) {
        messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
      }
    }
    setPreviousMessageCount(messages.length);
  }, [messages, previousMessageCount]);
  
  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-full">
        <Loader2 className="h-8 w-8 text-[#00B6F0] animate-spin" />
        <p className="text-gray-400 mt-2">Carregando mensagens...</p>
      </div>
    );
  }
  
  if (messages.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-full text-center p-4">
        <p className="text-gray-400">
          Nenhuma mensagem ainda. Comece a conversa enviando uma mensagem abaixo.
        </p>
      </div>
    );
  }

  return (
    <div 
      ref={messagesContainerRef} 
      className="flex-1 overflow-y-auto p-4 scroll-smooth"
      style={{ maxHeight: 'calc(100% - 120px)' }}
    >
      <div className="space-y-3">
        {messages.map((message) => (
          <MessageItem key={message.id} message={message} />
        ))}
      </div>
      <div ref={messagesEndRef} className="h-1" />
    </div>
  );
};
